<template>
    <div data-component="InstanceRedemptionBox"
         class="redemption-box instance-redemption-box"
         :class="{
             'first': itemInstanceIndex === 0,
             'instance-redemption-box__selected': itemInstance.itemInstanceRef === routeInstanceRef
         }">
        <div class="redemption-box__flex">
            <div class="redemption-box__title"
                 data-testid="redemptionBoxTitle">
                <span>{{ l('TICKET') }} {{
                    itemInstance.instance
                }}</span>
                <span class="redemption-box__ref">{{
                    itemInstance.itemInstanceRef
                }}</span>

                <Fields v-slot:default="{ fieldGroups }"
                        :field-group-collection="currentOrder.fields"
                        level="item"
                        :line-number="orderItem.lineNumber"
                        :item-instance="itemInstance"
                        :item-instance-index="itemInstanceIndex"
                        :hide-no-value="true">
                    <ul v-for="fieldGroup in fieldGroups"
                        :key="fieldGroup.id"
                        class="one-instance-field-data">
                        <li v-for="instance in sortedInstances(fieldGroup)"
                            :key="instance.key">
                            <strong>{{ instance.field.name }}:</strong>
                            <FieldInstance :instance="instance" />
                        </li>
                    </ul>
                </Fields>
            </div>

            <button v-if="orderItem.isRedemptionAllowed() && !itemInstance.redemptionError"
                    data-testid="unredeemItemInstanceCheckButton"
                    :disabled="!redemptionEnabledForOrderLine || itemInstance.netRedemptions <= 0 || itemInstance.redemptionIsInProgress()"
                    class="btn btn-lg btn-danger"
                    type="button"
                    @click.prevent="unredeemItemInstanceCheck()">
                <span class="fa-solid fa-lg"
                      :class="[itemInstance.unredemptionInProgress ? 'fa-arrows-rotate fa-spin' : 'fa-circle-minus']"></span>
            </button>

            <button v-if="orderItem.isRedemptionAllowed() && !itemInstance.redemptionError"
                    data-testid="redeemItemInstanceButton"
                    :disabled="!redemptionEnabledForOrderLine || itemInstance.netRedemptions > 0 || itemInstance.redemptionIsInProgress()"
                    class="btn btn-lg"
                    :class="[orderItem.getRedeemButtonColorClass(currentBranch.ID, true)]"
                    type="button"
                    @click.prevent="redeemItemInstance()">
                <span class="fa-solid fa-lg"
                      :class="[itemInstance.redemptionInProgress ? 'fa-arrows-rotate fa-spin' : 'fa-circle-plus']"></span>
            </button>
        </div>

        <!-- Redemption status messages for this instance -->
        <div class="redemption-box__status_messages"
             data-testid="redemptionBoxStatusMessages">
            <div v-if="!orderItem.isRedemptionAllowed() && itemInstance.netRedemptions > 0">
                <!-- If redemption buttons are not shown show if it has already been redeemed. -->
                <span class="indicator indicator-success">
                    {{ l('ORDER_DETAILS.TICKET_STATUS_REDEEMED') }}
                </span>
            </div>
            <!-- Display an expired ticket as not redeemed as blank looks a bit out of place. -->
            <div v-if="!orderItem.isRedemptionAllowed() && orderItem.redeemed == 0">
                <span class="indicator indicator-danger">
                    {{ l('ORDER_DETAILS.TICKET_STATUS_NOT_REDEEMED') }}
                </span>
            </div>
            <div v-if="orderItem.redeemable === false">
                <span class="indicator indicator-danger">
                    {{ l('ORDER_DETAILS.TICKET_STATUS_UNREDEEMABLE') }}
                </span>
            </div>
            <div v-if="itemInstance.redemptionError">
                <span class="indicator indicator-danger">
                    {{ l('ORDER_DETAILS.TICKET_STATUS_REDEMPTION_ERROR') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import EventNames from '@/lib/Events/EventNames';
import FieldInstance from '@/epos/vue/pages/order-details/components/FieldInstance';
import Fields from '@/epos/vue/pages/order-details/components/Fields';
import { container } from '@/container';
import { mapState } from 'vuex';
import { redemptionEnabledForOrderLineCheck } from '@/epos/vue/pages/order-details/functions/redemptionFunctions';

export default {
    name: 'InstanceRedemptionBox',

    components: {
        Fields,
        FieldInstance,
    },

    props: {
        currentOrder: {
            type: Object,
            required: true,
        },

        itemInstance: {
            type: Object,
            required: true,
        },

        itemInstanceIndex: {
            type: Number,
            required: true,
        },

        orderItem: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapState(['currentBranch']),

        routeInstanceRef() {
            return this.$route?.query?.instanceRef;
        },

        redemptionEnabledForOrderLine() {
            return redemptionEnabledForOrderLineCheck(this.orderItem);
        },
    },

    methods: {
        redeemItemInstance() {
            container.eventBus.broadcast(
                EventNames.INSTANCE_REDEMPTION_BOX_REDEEM_ITEM_INSTANCE,
                {
                    orderLineID: this.orderItem.ID,
                    itemInstanceID: this.itemInstance.ID,
                }
            );
        },

        unredeemItemInstanceCheck() {
            container.eventBus.broadcast(
                EventNames.INSTANCE_REDEMPTION_BOX_UNREDEEM_ITEM_INSTANCE_CHECK,
                {
                    orderLineID: this.orderItem.ID,
                    itemInstanceID: this.itemInstance.ID,
                }
            );
        },

        sortedInstances(fieldGroup) {
            return [...fieldGroup.instances].sort(
                (a, b) => a.field.navOrder - b.field.navOrder
            );
        },
    },
};
</script>
